module.exports = __webpack_public_path__ + "assets/img/product-function-img.f5161b86.png";